/** Vue injection key for providing the IoC container through the component tree. */
export const injectionKey = Symbol('container');
//# sourceMappingURL=injectionKey.js.map